// Third party and libarries
import React, { useState, useEffect, useRef } from "react";
import brandMark from "../image/4bMark.png";
import SideNav, {
  Toggle,
  NavItem,
  NavIcon,
  NavText,
} from "@trendmicro/react-sidenav";
import "@trendmicro/react-sidenav/dist/react-sidenav.css";
import _ from "lodash";
import { useQuery, useSubscription, useApolloClient } from "@apollo/client";
import Cookies from "js-cookie";
import ReactAudioPlayer from "react-audio-player";

//icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faVideo,
  faBoxOpen,
  faStore,
  faBoxes,
  faPhoneVolume,
  faCogs,
  faChartLine,
  faUsers,
  faCoins,
  faNewspaper,
  faTelevision,
  faBuildingUser,
  faComment,
  // faFileInvoice,
  // faBullseye,
  // faImages,
  // faLink,
  // faChartBar,
} from "@fortawesome/free-solid-svg-icons";
import { MdSecurity, MdOutlineLogout } from "react-icons/md";
import { BsCreditCard2BackFill } from "react-icons/bs";

// component and constants
import useWindowDimensions from "../helpers/useWindowDimensions";
import Swal from "sweetalert2";
import { GET_CHECK_ORDER } from "../graphql/order/query";
import {
  ACCESS_TOKEN,
  COLOR_APP,
  SHOP_DATA,
  SHOP_ID_FOR_TEST,
  SHOW_NOTICE_EXPIRED,
  SERVER_URI,
  USER_KEY2,
} from "../constants";
import { GET_TRANSACTIONS } from "../graphql/wallet/query";
import { SUBSCRIPTION_NOTICATION_SIDENAV } from "../graphql/sideNav/subscription";
import { SHOP } from "../graphql/shop/queryShop";
import { NOTICFY_ORDER_CANCEL } from "../graphql/order/query";

// style css
import "./sidenav.css";
import { GET_SETTING_BY_SHOP } from "../graphql/setting/query";
// import { io } from "socket.io-client";

const selectedTabbackground = "#ffffff";
const UN_SELECTED_TAB_TEXT = "#fff";

const popNoti = {
  position: "absolute",
  top: 0,
  left: 20,
  minWidth: 18,
  width: "auto",
  height: 18,
  fontSize: 12,
  borderRadius: "50%",
  background: "red",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: "#fff",
};

export default function Sidenav({ location, history }) {
  const client = useApolloClient();
  const shopData = JSON.parse(localStorage.getItem("SHOP_DATA"));
  const [socketConnected, setSocketConnected] = useState(false);
  const socketRef = useRef(null);

  // const { fetchOrder } = useSelector((state) => state?.salepage);

  const { height, width } = useWindowDimensions();
  const [selected, setSelectStatus] = useState(
    location.pathname.split("/")[1].split("-")[0],
  );
  const [expandedStatus, setExpandedStatus] = useState(false);
  const [role, setRole] = React.useState("");
  const soundPlayer = useRef();

  const [isClick, setIsClick] = useState(false);
  const [notification, setNotification] = useState(0);
  const [hasNewNotification, setHasNewNotification] = useState();

  // State to store activity orders
  const [isLoading, setIsLoading] = useState(false);

  // Effect to fetch activity orders with delay
  useEffect(() => {
    let timeoutId;
    const fetchActivityOrders = async () => {
      try {
        setIsLoading(true);
        //* client.query คืนผลได้ครั้งเดียว ใช้ cache-and-network ไม่ได้ (Apollo โยน InvariantViolation ทิ้งทันที)
        const response = await client.query({
          query: NOTICFY_ORDER_CANCEL,
          fetchPolicy: "network-only",
        });
        setNotification(response.data?.notifyOrdersCancel.total);
      } catch (error) {
        console.error("Error fetching activity orders:", error);
      } finally {
        setIsLoading(false);
      }
    };

    if (shopData?.id) {
      timeoutId = setTimeout(() => {
        fetchActivityOrders();
      }, 15000);
    }
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [shopData?.id]);

  const {
    data: checkOrderSalePage,
    loading,
    refetch,
  } = useQuery(GET_CHECK_ORDER, {
    fetchPolicy: "cache-and-network",
    variables: {
      where: {
        shop: shopData?.id,
        isDeleted: false,
        status: ["CREATED"],
        type: "SALE_PAGE",
      },
    },
  });

  const { data: shopInfo } = useQuery(SHOP, {
    fetchPolicy: "cache-and-network",
    variables: {
      where: {
        id: shopData?.id,
      },
    },
  });

  // setting by shop
  const { data: settingData, refetch: fetchSettingData } = useQuery(
    GET_SETTING_BY_SHOP,
    {
      fetchPolicy: "network-only",
      variables: {
        where: {
          shop: shopData?.id,
        },
      },
    },
  );

  const {
    data: checkOrder,
    loading: orderLoading,
    refetch: refetchOrder,
  } = useQuery(GET_CHECK_ORDER, {
    fetchPolicy: "network-only",
    variables: {
      where: {
        shop: shopData?.id,
        isDeleted: false,
        status: "CREATED",
      },
    },
  });

  // get credit for shop
  const { data: transactionDatas, refetch: refetchTransactionAll } = useQuery(
    GET_TRANSACTIONS,
    {
      fetchPolicy: "network-only",
      variables: {
        where: {
          shopId: shopData?.id,
        },
      },
    },
  );

  const { data: onNoticationSideNav } = useSubscription(
    SUBSCRIPTION_NOTICATION_SIDENAV,
    {
      variables: {
        shopId: shopData?.id,
      },
    },
  );

  const totalOrderGroup =
    checkOrderSalePage?.totalOrderGroup?.total + notification;
  const totalOrder = checkOrder?.totalOrderGroup?.total;
  const totalTransaction =
    transactionDatas?.getAllTransactions?.reports?.chartDatas?.filter(
      (data) => _.isEmpty(data?.billStatus) && _.isEmpty(data?.bill),
    );

  useEffect(() => {
    refetch();
    refetchOrder();
    fetchSettingData();
    // soundPlayer.current.audioEl.current.play()
  }, [selected]);

  // useEffect(() => {
  //   if (!shopData?.id) return;

  //   const isLocal = SERVER_URI?.startsWith('http://localhost');
  //   socketRef.current = io(SERVER_URI, {
  //     path: '/socket.io/',
  //     transports: isLocal ? ['polling'] : ['websocket', 'polling'],
  //     upgrade: !isLocal,
  //     timeout: 5000,
  //     reconnection: true,
  //     reconnectionAttempts: 3,
  //     reconnectionDelay: 1000,
  //     auth: { token: Cookies.get(ACCESS_TOKEN) },
  //     query: { shopId: shopData.id }
  //   });

  //   socketRef.current.on("connect", () => {
  //     socketRef.current.emit("joinShopRefund", shopData.id);
  //     setSocketConnected(true);
  //   });

  //   socketRef.current.on("disconnect", () => {
  //     setSocketConnected(false);
  //   });

  //   socketRef.current.on("connect_error", () => {
  //     if (isLocal && socketRef.current?.io?.opts?.transports?.includes('websocket')) {
  //       socketRef.current.io.opts.transports = ['polling'];
  //       socketRef.current.io.opts.upgrade = false;
  //       socketRef.current.connect();
  //     }
  //   });

  //   socketRef.current.on("newRefundRequest", (data) => {
  //     if (shopData?.id === data.shopId) {
  //       fetchNotication(data);
  //     }
  //   });

  //   const handleVisibility = () => {
  //     if (!socketRef.current) return;
  //     if (document.visibilityState === 'hidden') {
  //       socketRef.current.disconnect();
  //     } else {
  //       socketRef.current.connect();
  //     }
  //   };
  //   document.addEventListener('visibilitychange', handleVisibility);

  //   return () => {
  //     document.removeEventListener('visibilitychange', handleVisibility);
  //     if (socketRef.current) {
  //       socketRef.current.disconnect();
  //       socketRef.current = null;
  //     }
  //   };
  // }, [shopData?.id]);

  const fetchNotication = async (data) => {
    setNotification((prev) => prev + 1);
    setHasNewNotification(data);
  };

  useEffect(() => {
    if (!hasNewNotification) return;
    console.log("Now React applied the new state:", hasNewNotification);
  }, [hasNewNotification]);

  useEffect(() => {
    if (settingData) {
      localStorage.setItem(
        "SHOP_SETTING_DATA",
        JSON.stringify(settingData?.settingByShopId),
      );
    }
  }, [settingData]);

  // fetch notication credit
  const fetchNoticationCredit = async () => {
    try {
      await refetchTransactionAll();

      soundPlayer.current.audioEl.current.play();

      // alert notification
      Swal.fire({
        icon: "info",
        title: "ແຈ້ງເຕືອນ!",
        position: "bottom-end",
        html: `ມີອໍເດີ້ເຂົ້າໃໝ່ ຈາກການຊຳລະຜ່ານ payment support ຄຣິກປຸ່ມ <br> "ເບິ່ງລາຍລະອຽດ" <br>ເພື່ອກວດສອບຍອດເງິນຂອງທ່ານ`,
        showDenyButton: false,
        showCancelButton: false,
        confirmButtonText: "ເບິ່ງລາຍລະອຽດ",
        timer: 18000,
        backdrop: false,
      }).then((result) => {
        if (result.isConfirmed) {
          history.push("/wallet_store/limit/50/page/1");
        }
      });
    } catch (error) {
      console.error({ error });
    }
  };

  const isPathInclude = (condition) =>
    _.includes(condition, selected.split("/page")[0]);
  const getRoles = async () => {
    setRole(localStorage.getItem("ROLE"));
  };

  const hadleLogout = () => {
    setIsClick(true);
    Swal.fire({
      title: "ແຈ້ງເຕືອນ!",
      text: "ທ່ານຕ້ອງການອອກຈາກລະບົບແທ້ບໍ",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#35a54a2",
      confirmButtonColor: "#1a66be",
      cancelButtonText: "ຍົກເລີກ",
      confirmButtonText: "ຢືນຢັນ",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.clear();
        localStorage.removeItem(USER_KEY2);
        localStorage.removeItem("SHOP");
        localStorage.removeItem("@userKey");
        localStorage.removeItem("SHOP_PAGE");
        localStorage.removeItem("persist:root");
        localStorage.removeItem(SHOP_DATA);
        sessionStorage.clear();
        Cookies.remove(ACCESS_TOKEN);
        Cookies.remove(ACCESS_TOKEN);
        Cookies.remove("SHOP_PAGE");
        Cookies.remove(SHOW_NOTICE_EXPIRED);
        history.push(`/`);
      }
    });
  };

  return (
    <>
      <ReactAudioPlayer src="/assets/audio/notic_v1.mp3" ref={soundPlayer} />

      {width > 700 && (
        <SideNav
          style={{
            background: COLOR_APP,
            height: "100vh",
            display: "block",
            position: "fixed",
            top: width <= 700 ? 65 : 0,
          }}
          expanded={expandedStatus}
          onSelect={(selected) => {
            // console.log(selected);
            setSelectStatus(selected);
            const to = "/" + selected;
            if (location.pathname !== to) {
              // console.log("to: ", to)
              if (to === "/live-manage") {
                return history.push(to + "/active/limit/50/page/1");
              }
              if (
                to === "/products" ||
                to === "/orders" ||
                to === "/wallet_store" ||
                to === "/stored_delivery"
              ) {
                history.push(to + "/limit/50/page/1");
              } else if (to === "/logout") {
                hadleLogout();
              } else {
                history.push(to);
              }
            }
          }}
          onToggle={(expanded) => {
            setExpandedStatus(expanded);
          }}
        >
          {width > 700 && <Toggle />}

          {/**
            * The mark, pinned to the RIGHT end of the header row.
            *
            * The Toggle owns the left. Putting the logo opposite it uses space that was
            * already empty, so nothing below shifts — and a circle reads as a brand mark
            * at this size where the full wordmark would just be a smudge.
            *
            * Cropped from logo_main.png (src/image/4bMark.png) rather than public/4bLogo.png,
            * which is the older blue circular mark and would look like a different company
            * sitting on a red rail.
            */}
          {expandedStatus && (
            <img
              src={brandMark}
              alt="4B For Business"
              style={{
                position: "absolute",
                top: 12,
                right: 16,
                width: 40,
                height: 40,
                borderRadius: "50%",
                objectFit: "cover",
                background: "#fff",
                boxShadow: "0 2px 8px rgba(0,0,0,.25)",
                zIndex: 2,
              }}
            />
          )}

          {/**
            * The rail scrolls.
            *
            * A LIVE shop renders ~20 items at the library's 50px row height — about 1060px
            * with the Toggle — inside a `position: fixed; height: 100vh` box that had no
            * overflow rule anywhere, in this file or in the library. On any laptop viewport
            * (~760px) that left the last several items, ຕັ້ງຄ່າ and ອອກຈາກລະບົບ among them,
            * spilled past the bottom edge with no way to reach them.
            *
            * `paddingBottom` is the height of the ນະໂຍບາຍຄວາມປອດໄພ item below, which is
            * absolutely positioned against the fixed rail rather than this scroller — so it
            * stays pinned to the viewport bottom exactly as before, and the padding keeps
            * scrolled content from ending underneath it. Nothing moves; things that were
            * unreachable become reachable.
            */}
          <SideNav.Nav
            value={location.pathname}
            onMouseOver={(e) => {
              // ຕອນຫຸບ ເມນູຍ່ອຍເປັນ position: fixed (ເບິ່ງ sidenav.css) — ວາງໃຫ້ຢູ່ລະດັບດຽວກັບເມນູທີ່ hover
              if (expandedStatus) return;
              const item = e.target.closest(".sidenav---sidenav-navitem---uwIJ-");
              const subnav = item?.querySelector(":scope > .sidenav---sidenav-subnav---1EN61");
              if (!subnav) return;
              const rect = item.getBoundingClientRect();
              // ບໍ່ໃຫ້ລົ້ນຂອບລຸ່ມຂອງຈໍ
              const maxTop = window.innerHeight - subnav.offsetHeight;
              subnav.style.top = `${Math.max(0, Math.min(rect.top, maxTop))}px`;
              // ຕິດຂອບຂວາຂອງເມນູພໍດີ (ຊ້ອນ 1px) — ບໍ່ໃຫ້ມີຊ່ອງວ່າງທີ່ເຮັດໃຫ້ hover ຫຼຸດ
              subnav.style.left = `${rect.right - 1}px`;
            }}
            style={{
              maxHeight: "calc(100vh - 64px)",
              overflowY: "auto",
              overflowX: "hidden",
              paddingBottom: 56,
            }}
          >
            <hr style={{ marginTop: "-.5em", borderColor: "rgba(255,255,255,.18)" }} />

            <NavItem
              eventKey="dashboard"
              style={{
                background: isPathInclude(["dashboard"]) ? "#ffff" : "",
                border: "none",
              }}
            >
              <NavIcon>
                <FontAwesomeIcon
                  icon={faChartLine}
                  style={{
                    color: isPathInclude(["dashboard"])
                      ? "red"
                      : selectedTabbackground,
                  }}
                />
              </NavIcon>
              <NavText
                style={{
                  color: isPathInclude(["dashboard"])
                    ? "red"
                    : UN_SELECTED_TAB_TEXT,
                }}
              >
                ສະຖິຕິ
              </NavText>
            </NavItem>

            {/* TotalSummary */}
            <NavItem
              eventKey="total-summary"
              style={{
                background: isPathInclude(["total-summary"]) ? "#ffff" : "",
                border: "none",
              }}
            >
              <NavIcon>
                <FontAwesomeIcon
                  icon={faNewspaper}
                  style={{
                    color: isPathInclude(["total-summary"])
                      ? "red"
                      : selectedTabbackground,
                  }}
                />
              </NavIcon>
              <NavText
                style={{
                  color: isPathInclude(["total-summary"])
                    ? "red"
                    : UN_SELECTED_TAB_TEXT,
                }}
              >
                ສະຫລຸບຍອດ
              </NavText>
            </NavItem>

            {shopInfo?.shop?.systems.includes("LIVE") ? (
              <NavItem
                eventKey="live-manage"
                style={{
                  background:
                    isPathInclude(["live-manage"]) || isPathInclude(["live"])
                      ? "#ffff"
                      : "",
                  border: "none",
                }}
              >
                <NavIcon>
                  <FontAwesomeIcon
                    icon={faVideo}
                    style={{
                      color:
                        isPathInclude(["live-manage"]) ||
                        isPathInclude(["live"])
                          ? "red"
                          : selectedTabbackground,
                    }}
                  />
                </NavIcon>
                <NavText
                  style={{
                    color:
                      isPathInclude(["live-manage"]) || isPathInclude(["live"])
                        ? "red"
                        : UN_SELECTED_TAB_TEXT,
                  }}
                >
                  Live Streaming
                </NavText>
              </NavItem>
            ) : (
              ""
            )}

            {shopInfo?.shop?.systems.includes("LIVE") ? (
              <NavItem
                eventKey="post-feed"
                style={{
                  background:
                    isPathInclude(["post-feed"]) || isPathInclude(["post"])
                      ? "#ffff"
                      : "",
                  border: "none",
                }}
              >
                <NavIcon>
                  <FontAwesomeIcon
                    icon={faCoins}
                    style={{
                      color:
                        isPathInclude(["post-feed"]) || isPathInclude(["post"])
                          ? "red"
                          : selectedTabbackground,
                    }}
                  />
                </NavIcon>
                <NavText
                  style={{
                    color:
                      isPathInclude(["post-feed"]) || isPathInclude(["post"])
                        ? "red"
                        : UN_SELECTED_TAB_TEXT,
                  }}
                >
                  Post
                </NavText>
              </NavItem>
            ) : (
              ""
            )}

            <NavItem
              eventKey="messenger-inbox"
              style={{
                background: isPathInclude(["messenger-inbox"]) ? "#ffff" : "",
                border: "none",
              }}
            >
              <NavIcon>
                <FontAwesomeIcon
                  icon={faComment}
                  style={{
                    color: isPathInclude(["messenger-inbox"])
                      ? "red"
                      : selectedTabbackground,
                  }}
                />
              </NavIcon>
              <NavText
                style={{
                  color: isPathInclude(["messenger-inbox"])
                    ? "red"
                    : UN_SELECTED_TAB_TEXT,
                }}
              >
                Chat
              </NavText>
            </NavItem>

            {/* shopInfo?.systems.includes("LIVE") && */}

            {shopInfo?.shop?.systems.includes("SALE_PAGE") ? (
              <NavItem
                eventKey="salepage"
                style={{
                  background:
                    isPathInclude(["advertising-sale-page"]) ||
                    isPathInclude(["invoices/create-invoice"]) ||
                    isPathInclude(["setting-salepage"]) ||
                    isPathInclude(["infulancer/infulancer-link-list"]) ||
                    isPathInclude(["view-stats"])
                      ? "#ffff"
                      : "",
                  color:
                    isPathInclude(["advertising-sale-page"]) ||
                    isPathInclude(["setting-salepage"]) ||
                    isPathInclude(["invoices/create-invoice"]) ||
                    isPathInclude(["infulancer/infulancer-link-list"]) ||
                    isPathInclude(["view-stats"])
                      ? "red"
                      : selectedTabbackground,
                }}
              >
                <NavIcon style={{ position: "relative" }}>
                  <FontAwesomeIcon
                    icon={faTelevision}
                    style={{
                      background:
                        isPathInclude(["advertising-sale-page"]) ||
                        isPathInclude(["invoices/create-invoice"]) ||
                        isPathInclude(["setting-salepage"]) ||
                        isPathInclude(["infulancer/infulancer-link-list"]) ||
                        isPathInclude(["view-stats"])
                          ? "#ffff"
                          : "",
                      color:
                        isPathInclude(["advertising-sale-page"]) ||
                        isPathInclude(["invoices/create-invoice"]) ||
                        isPathInclude(["setting-salepage"]) ||
                        isPathInclude(["infulancer/infulancer-link-list"]) ||
                        isPathInclude(["view-stats"])
                          ? "red"
                          : selectedTabbackground,
                    }}
                  />

                  {/* noti */}
                  {totalOrderGroup ? (
                    <span style={popNoti}>{totalOrderGroup}</span>
                  ) : (
                    ""
                  )}
                </NavIcon>

                <NavText
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    color:
                      isPathInclude(["advertising-sale-page"]) ||
                      isPathInclude(["invoices/create-invoice"]) ||
                      isPathInclude(["setting-salepage"]) ||
                      isPathInclude(["infulancer/infulancer-link-list"]) ||
                      isPathInclude(["view-stats"])
                        ? "red"
                        : selectedTabbackground,
                  }}
                >
                  ເຊວເພຈ
                </NavText>

                <NavItem
                  eventKey="advertising-sale-page"
                  style={{ height: 40 }}
                >
                  <NavText
                    style={{
                      height: 40,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "flex-start",
                      alignItems: "center",
                    }}
                  >
                    <p style={{ margin: 0 }}>ຈັດການແບນເນີ</p>
                  </NavText>
                </NavItem>

                <NavItem
                  eventKey="invoices/create-invoice"
                  style={{ height: 40 }}
                >
                  <NavText
                    style={{
                      height: 40,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      color: notification ? "red" : "black",
                    }}
                  >
                    {/* <div style={{ width: 15 }} /> */}
                    {/* <FontAwesomeIcon icon={faBoxes} />
                    <div style={{ width: 10 }} /> */}
                    <p style={{ margin: 0 }}>ອໍເດີເຊວເພຈ</p>
                  </NavText>
                </NavItem>

                <NavItem
                  eventKey="infulancer/infulancer-link-list"
                  style={{ height: 40 }}
                >
                  <NavText
                    style={{
                      height: 40,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "flex-start",
                      alignItems: "center",
                    }}
                  >
                    {/* <FontAwesomeIcon icon={faLink} /> */}
                    {/* <div style={{ width: 10 }} /> */}
                    <p style={{ margin: 0 }}>ສ້າງລິ້ງ ອາຟຣິລີເອດ</p>
                  </NavText>
                </NavItem>
                <NavItem eventKey="view-stats" style={{ height: 40 }}>
                  <NavText
                    style={{
                      height: 40,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "flex-start",
                      alignItems: "center",
                    }}
                  >
                    {/* <FontAwesomeIcon icon={faLink} /> */}
                    {/* <div style={{ width: 10 }} /> */}
                    <p style={{ margin: 0 }}>ຕິດຕາມພາບລວມ</p>
                  </NavText>
                </NavItem>
              </NavItem>
            ) : (
              ""
            )}

            <hr />
            <NavItem
              eventKey="products"
              style={{
                background:
                  isPathInclude(["product-add"]) || isPathInclude(["products"])
                    ? "#ffff"
                    : "",
                border: "none",
              }}
            >
              <NavIcon>
                <FontAwesomeIcon
                  icon={faBoxOpen}
                  style={{
                    color:
                      isPathInclude(["product-add"]) ||
                      isPathInclude(["products"])
                        ? "red"
                        : selectedTabbackground,
                  }}
                />
              </NavIcon>
              <NavText
                style={{
                  color:
                    isPathInclude(["product-add"]) ||
                    isPathInclude(["products"])
                      ? "red"
                      : UN_SELECTED_TAB_TEXT,
                }}
              >
                ຈັດການສິນຄ້າ
              </NavText>
            </NavItem>

            <NavItem
              eventKey="orders"
              // eventKey="orders/page=1"
              style={{
                background: isPathInclude(["orders"]) ? "#ffff" : "",
                border: "none",
              }}
            >
              <NavIcon>
                <FontAwesomeIcon
                  icon={faBoxes}
                  style={{
                    color: isPathInclude(["orders"])
                      ? "red"
                      : selectedTabbackground,
                  }}
                />

                {totalOrder ? <span style={popNoti}>{totalOrder}</span> : ""}
              </NavIcon>
              <NavText
                style={{
                  color: isPathInclude(["orders"])
                    ? "red"
                    : UN_SELECTED_TAB_TEXT,
                }}
              >
                ຈັດການອໍເດີ້
              </NavText>
            </NavItem>


            {/* <NavItem
              eventKey="stories"
              style={{
                background: isPathInclude(["stored_delivery"]) ? "#ffff" : "",
              }}
            >
              <NavIcon style={{ position: "relative" }}>
                <FontAwesomeIcon
                  style={{
                    color:
                      isPathInclude(["stored_delivery"])
                        ? "red"
                        : "#ffffff",
                  }}
                  icon={faChartBar}
                />
              </NavIcon>
              <NavText>
                ລາຍງານປະຫວັດ
              </NavText>
              <NavItem eventKey="stored_delivery">
                <NavText style={{
                  padding: 5,
                }}>
                  ປະຫວັດອໍເດີ້ຈັດສົ່ງ
                </NavText>
              </NavItem>
            </NavItem>
             */}
            {shopInfo?.shop?.systems.includes("LIVE") &&
            shopData?.id === "63ec6d38c617221e6ccf5edc" ? (
              <NavItem
                eventKey="user-cf"
                style={{
                  background:
                    isPathInclude(["user-cf"]) || isPathInclude(["user"])
                      ? "#ffff"
                      : "",
                  border: "none",
                }}
              >
                <NavIcon>
                  <FontAwesomeIcon
                    icon={faUsers}
                    style={{
                      color:
                        isPathInclude(["user-cf"]) || isPathInclude(["user"])
                          ? "red"
                          : selectedTabbackground,
                    }}
                  />
                </NavIcon>
                <NavText
                  style={{
                    color:
                      isPathInclude(["user-cf"]) || isPathInclude(["user"])
                        ? "red"
                        : UN_SELECTED_TAB_TEXT,
                  }}
                >
                  ຈັດການລູກຄ້າ
                </NavText>
              </NavItem>
            ) : (
              ""
            )}

            {/* ລູກຄ້າ CF — ລາຍຊື່ລູກຄ້າທຸກຄົນທີ່ເຄີຍ CF ສັ່ງສິນຄ້າ ພ້ອມປະຫວັດການສັ່ງ */}
            <NavItem
              eventKey="customer-cf-list"
              style={{
                background: isPathInclude(["customer-cf"]) ? "#ffff" : "",
                border: "none",
              }}
            >
              <NavIcon>
                <FontAwesomeIcon
                  icon={faBuildingUser}
                  style={{
                    color: isPathInclude(["customer-cf"])
                      ? "red"
                      : selectedTabbackground,
                  }}
                />
              </NavIcon>
              <NavText
                style={{
                  color: isPathInclude(["customer-cf"])
                    ? "red"
                    : UN_SELECTED_TAB_TEXT,
                }}
              >
                ຈັດການຂໍ້ມູນລູກຄ້າ
              </NavText>
            </NavItem>

            {(settingData?.settingByShopId?.isPaymentGateway ||
              (settingData?.settingByShopId?.shop?.systems
                ? settingData?.settingByShopId?.shop?.systems.includes(
                    "SALE_PAGE",
                  )
                : false)) && (
              <NavItem
                eventKey="wallet_store"
                style={{
                  background: isPathInclude(["wallet_store"]) ? "#ffff" : "",
                  border: "none",
                  position: "relative",
                }}
              >
                <NavIcon>
                  <BsCreditCard2BackFill
                    style={{
                      color: isPathInclude(["wallet_store"])
                        ? "red"
                        : selectedTabbackground,
                      fontSize: 20,
                    }}
                  />
                </NavIcon>
                <NavText
                  style={{
                    color: isPathInclude(["wallet_store"])
                      ? "red"
                      : UN_SELECTED_TAB_TEXT,
                  }}
                >
                  ກະເປົາຂອງຂ້ອຍ
                </NavText>
                {!_.isEmpty(totalTransaction) && (
                  <span style={popNoti}>{totalTransaction?.length ?? 0}</span>
                )}
              </NavItem>
            )}

            <hr />

            <NavItem
              eventKey="settings"
              style={{
                background: isPathInclude(["settings"]) ? "#ffff" : "",
                border: "none",
              }}
            >
              <NavIcon>
                <FontAwesomeIcon
                  icon={faCogs}
                  style={{
                    color: isPathInclude(["settings"])
                      ? "red"
                      : selectedTabbackground,
                  }}
                />
              </NavIcon>
              <NavText
                style={{
                  color: isPathInclude(["settings"])
                    ? "red"
                    : UN_SELECTED_TAB_TEXT,
                }}
              >
                ຕັ້ງຄ່າ
              </NavText>
            </NavItem>
            {role == "LAILAOLAB" && (
              <NavItem
                eventKey="shops"
                style={{
                  background: isPathInclude(["shops"]) ? "#ffff" : "",
                  border: "none",
                }}
              >
                <NavIcon>
                  <FontAwesomeIcon
                    icon={faStore}
                    style={{
                      color: isPathInclude(["shops"])
                        ? "red"
                        : selectedTabbackground,
                    }}
                  />
                </NavIcon>
                <NavText
                  style={{
                    color: isPathInclude(["shops"])
                      ? "red"
                      : UN_SELECTED_TAB_TEXT,
                  }}
                >
                  ຈັດການຮ້ານຄ້າ
                </NavText>
              </NavItem>
            )}

            <NavItem
              eventKey="logout"
              style={{
                // background: isClick === true ? "#ffff" : "",
                border: "none",
              }}
              onClick={hadleLogout}
            >
              <NavIcon>
                <MdOutlineLogout
                  // icon={faCogs}
                  style={{
                    // color:
                    // isClick === true ? "red" : selectedTabbackground,
                    fontSize: 22,
                  }}
                />
              </NavIcon>
              <NavText>ອອກຈາກລະບົບ</NavText>
            </NavItem>

            <NavItem
              eventKey="privacy-policy"
              style={{
                background: isPathInclude(["privacy-policy"]) ? "#ffff" : "",
                border: "none",
                position: "absolute",
                bottom: 0,
                left: 0,
                width: "100%",
              }}
            >
              <NavIcon>
                <MdSecurity
                  style={{
                    color: isPathInclude(["privacy-policy"])
                      ? "red"
                      : selectedTabbackground,
                    fontSize: 20,
                  }}
                />
              </NavIcon>
              <NavText
                style={{
                  color: isPathInclude(["privacy-policy"])
                    ? "red"
                    : UN_SELECTED_TAB_TEXT,
                }}
              >
                ນະໂຍບາຍຄວາມປອດໄພ
              </NavText>
            </NavItem>

            {/* Parked at the very bottom deliberately: this screen only exists to eyeball
                what the parser read while P5 is being proved out. It is not part of anyone's
                daily flow yet, so it should not sit among the items that are. Move it up to
                live beside ຈັດການອໍເດີ້ once shops actually work from it. */}
            {/* P5 — phone/address parsed out of chat, awaiting the BUYER's tap.
                NOT the same as the order status ລໍຖ້າການຍືນຍັນ (WAITINGCONFIRM), which is an
                ORDER waiting on the SHOP. Named for the data, not the waiting, so the two
                cannot be read as the same queue. The draft is never discarded and never
                applied on its own, so this is where a human finishes what the buyer did not. */}
            <NavItem
              eventKey="contact-drafts"
              style={{
                background: isPathInclude(["contact-drafts"]) ? "#ffff" : "",
                border: "none",
              }}
            >
              <NavIcon>
                <FontAwesomeIcon
                  icon={faPhoneVolume}
                  style={{
                    color: isPathInclude(["contact-drafts"])
                      ? "red"
                      : selectedTabbackground,
                  }}
                />
              </NavIcon>
              <NavText
                style={{
                  color: isPathInclude(["contact-drafts"])
                    ? "red"
                    : UN_SELECTED_TAB_TEXT,
                }}
              >
                ເບີ/ທີ່ຢູ່ຈາກແຊັດ
              </NavText>
            </NavItem>

          </SideNav.Nav>
        </SideNav>
      )}
    </>
  );
}
